import React, { useState, useEffect, useRef } from "react";
import CodeMirror from "@uiw/react-codemirror";
import * as Babel from "@babel/standalone";
import "./ReactCodeEditorTerminal.css";

export default function ReactCodeEditorTerminal() {
  const [code, setCode] = useState(`
function App() {
  const [count, setCount] = React.useState(0);
  return (
    <div style={{ fontFamily: "sans-serif", textAlign: "center" }}>
      <h1>Hello React Live!</h1>
      <p>Count: {count}</p>
      <button onClick={() => setCount(count + 1)}>Increment</button>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
`);
  const [consoleLogs, setConsoleLogs] = useState([]);
  const [isConsoleOpen, setIsConsoleOpen] = useState(false);
  const iframeRef = useRef(null);

  // === Run user code inside iframe ===
  const runCode = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    let transformedCode = "";
    try {
      transformedCode = Babel.transform(code, {
        presets: ["react", "env"],
      }).code;
    } catch (err) {
      setConsoleLogs([`❌ Babel Error: ${err.message}`]);
      return;
    }

    const html = `
      <html>
        <head>
          <meta charset="UTF-8" />
          <script crossorigin src="https://unpkg.com/react@18/umd/react.development.js"></script>
          <script crossorigin src="https://unpkg.com/react-dom@18/umd/react-dom.development.js"></script>
        </head>
        <body style="margin:0;padding:0;">
          <div id="root"></div>
          <script>
            const console = {
              log: (...args) => parent.postMessage({ type: "log", args }, "*"),
              warn: (...args) => parent.postMessage({ type: "warn", args }, "*"),
              error: (...args) => parent.postMessage({ type: "error", args }, "*")
            };
            try {
              ${transformedCode}
            } catch (err) {
              parent.postMessage({ type: "error", args: [err.message] }, "*");
            }
          </script>
        </body>
      </html>
    `;

    iframe.srcdoc = html;
    setConsoleLogs([]);
  };

  // === Listen for console messages from iframe ===
  useEffect(() => {
    const listener = (event) => {
      const { type, args } = event.data || {};
      if (!type) return;
      if (type === "log") setConsoleLogs((prev) => [...prev, args.join(" ")]);
      if (type === "warn")
        setConsoleLogs((prev) => [...prev, "⚠️ " + args.join(" ")]);
      if (type === "error")
        setConsoleLogs((prev) => [...prev, "❌ " + args.join(" ")]);
    };
    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, []);

  return (
    <div className="react-terminal-container">
      <div className="top-pane">
        {/* ===== Code Editor ===== */}
        <div className="editor-pane">
          <div className="editor-header">
            <h3>💻 React Live Editor</h3>
            <button className="run-btn" onClick={runCode}>
              ▶ Run
            </button>
          </div>

          <div className="editor-body">
            <CodeMirror
              value={code}
              height="78.5vh"
              theme="dark"
              onChange={(value) => setCode(value)}
            />
          </div>
        </div>

        {/* ===== Preview + Console ===== */}
        <div className="preview-pane-Console">
          <div className="preview-pane">
            <iframe
              ref={iframeRef}
              title="React Preview"
              sandbox="allow-scripts allow-same-origin"
            />
          </div>

          {/* ===== Collapsible Console ===== */}
          <div className={`console-pane ${isConsoleOpen ? "open" : "closed"}`}>
            <div
              className="console-header"
              onClick={() => setIsConsoleOpen(!isConsoleOpen)}
            >
              <h3>🧠 Console Output</h3>
              <span className="toggle-icon">{isConsoleOpen ? "▼" : "▲"}</span>
            </div>

            <div className="console-content">
              {consoleLogs.length === 0 ? (
                <pre className="console-empty">No console logs yet...</pre>
              ) : (
                consoleLogs.map((log, i) => (
                  <pre key={i} className="console-log">
                    {log}
                  </pre>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
